import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=ddf6d2cc&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=ddf6d2cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf6d2cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddf6d2cc')) {
      api.createRecord('ddf6d2cc', component.options)
    } else {
      api.reload('ddf6d2cc', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=ddf6d2cc&scoped=true&", function () {
      api.rerender('ddf6d2cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25sdy7AQ8rsNt/JS/comp/DateRangeExt.vue"
export default component.exports